import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=1890dbec&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
import style0 from "./Nav.vue?vue&type=style&index=0&id=1890dbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890dbec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageSizesQL: require('C:/app/components/Helpers/ImageSizesQL.vue').default,NavLogo: require('C:/app/components/Svgs/NavLogo.vue').default,User: require('C:/app/components/Svgs/User.vue').default,Profile: require('C:/app/components/Navigation/Profile.vue').default,NavItem: require('C:/app/components/Navigation/NavItem.vue').default,NavLanguages: require('C:/app/components/Navigation/NavLanguages.vue').default,Nav: require('C:/app/components/Navigation/Nav.vue').default})
